export default () => {
    return (scope, element) => {
        element[0].focus();
    };
};



// WEBPACK FOOTER //
// ./src/app/common/common.directive/auto-focus.directive.js